import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { toast } from 'react-toastify';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';

import Strings from '../../../i18n';
import { SideBarEditablePropertyItem } from '../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { useResetFactoryControllerBadKeyMutation } from '../../../services/device/deviceService';
import { ResetFactoryControllerBadKeyProps } from './resetFactoryControllerProps';

export const ResetFactoryControllers = ({
  setOpenRightSideBar
}: ResetFactoryControllerBadKeyProps) => {
  const [macAddress, setMacAddress] = useState('');
  const [resetController, { isSuccess }] =
    useResetFactoryControllerBadKeyMutation();

  useEffect(() => {
    if (isSuccess) {
      setMacAddress('');
      toast.success(Strings.serverAccess.devices.successResetController);
      setOpenRightSideBar(false);
    }
  }, [isSuccess]);

  return (
    <Box>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.resetFactoryControllers}
        </StyledTitleSideBar>
        <SideBarEditablePropertyItem
          item={{
            label: Strings.devices.deviceId,
            type: 'inputText',
            currentValue: macAddress,
            placeholder: Strings.devices.enterDeviceId,
            onChange: (
              e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setMacAddress(e.target.value.toString())
          }}
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          disabled={!macAddress.length}
          onClick={() => {
            resetController({ deviceId: macAddress });
          }}
        >
          {Strings.common.add}
        </button>
      </StyledContainerFooterSideBar>
    </Box>
  );
};
